import * as Route from 'constants/routes';
import logo from 'images/logo-full.png';
import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const { pathname } = useLocation();

  const visibleOnlyPath = [
    Route.HOME,
    Route.SHOP
  ];

  return !visibleOnlyPath.includes(pathname) ? null : (
    <footer className="footer">
      <div className="footer-col-1">
        {/*<div className="policy-holder">*/}
        {/*  <p>Use constitutes acceptance of our*/}
        {/*  <a href="/Terms">Terms*/}
        {/*    of Use</a> &amp; <a href="/Privacy">Privacy Policy</a>.</p>*/}
        {/*</div>*/}
      </div>
      <div className="footer-col-2">
        <img alt="Footer logo" className="footer-logo" src={logo} />
      </div>
      <div className="footer-col-3">
        <div className="policy-holder-3">
          Developed by
          {' '}
          <a href="https://divercollective.com" target="_blank">{`Diver Collective` }</a>
          {/*{` ${new Date().getFullYear()} All rights reserved.`}*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
